<template>
  <div class="about">
    <rich-text-input v-model="aboutHTML" :simple="true" />
    <button @click="save" :disabled="isSaving">
      Save
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import RichTextInput from '@/components/RichTextInput.vue';

export default {
  name: 'ManageAbout',
  components: {
    RichTextInput,
  },
  computed: {
    ...mapGetters(['getSite']),
  },
  data() {
    return {
      aboutHTML: null,
      isSaving: false,
    };
  },
  created() {
    this.aboutHTML = this.getSite.aboutHTML;
  },
  watch: {
    getSite() {
      this.aboutHTML = this.getSite.aboutHTML;
    },
  },
  methods: {
    ...mapActions(['update']),
    save() {
      this.isSaving = true;
      this.update({
        model: 'site',
        id: 'about',
        value: {
          html: this.aboutHTML,
        },
      }).then(() => {
        this.isSaving = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.about {
  text-align: center;
  button {
    margin-top: 20px;
  }
}
</style>
